import React from "react";
import { Typography, Button } from "@mui/material";
import RoleCard from "./RoleCard";
import { isNotNullOrEmptyArray } from "../../globals/utils";

const RoleSelectionStep = ({
  appuserData,
  selectedRole,
  onRoleSelect,
  onNext,
  t,
}) => {
  return (
    <>
      <Typography variant="h6" align="center" mb={2}>
        {t("Login as")}
      </Typography>

      {/* Role selection cards */}
      <div style={{ marginBottom: "16px" }}>
        {isNotNullOrEmptyArray(appuserData) ? (
          appuserData.map((roleData, index) => (
            <RoleCard
              key={index}
              roleData={roleData}
              index={index}
              isSelected={selectedRole?.id === roleData.id}
              onSelect={onRoleSelect}
            />
          ))
        ) : (
          <Typography variant="body2" color="textSecondary" align="center">
            {t("No roles available. Please contact your administrator.")}
          </Typography>
        )}
      </div>

      <Button
        fullWidth
        variant="contained"
        color="primary"
        sx={{ mt: 2, color: "white" }}
        disabled={!selectedRole}
        onClick={onNext}
      >
        {t("Next")}
      </Button>
    </>
  );
};

export default RoleSelectionStep;
